import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { Subject } from 'rxjs';

import { CommonService } from './common';

@Injectable()
export class MyCustomPaginatorIntl implements MatPaginatorIntl {
    changes = new Subject<void>();

    // For internationalization, the `$localize` function from
    // the `@angular/localize` package can be used.
    firstPageLabel = this._common.t(`FIRST-PAGE`);
    itemsPerPageLabel = this._common.t(`ITEMS-PER-PAGE`) + ':';
    lastPageLabel = this._common.t(`LAST-PAGE`);

    // You can set labels to an arbitrary string too, or dynamically compute
    // it through other third-party internationalization libraries.
    nextPageLabel = this._common.t('NEXT-PAGE');
    previousPageLabel = this._common.t('PREVIOUS-PAGE');

    constructor(private _common: CommonService) {}

    getRangeLabel(page: number, pageSize: number, length: number): string {
        if (length === 0) {
            return `${this._common.t('PAGE')} 1 ${this._common.t('OF')} 1`;
        }
        const amountPages = Math.ceil(length / pageSize);
        return `${this._common.t('PAGE')} ${page + 1} ${this._common.t(
            'OF'
        )} ${amountPages}`;
    }
}
